import React, { FC, ReactNode, useEffect, useState, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useSelector, shallowEqual } from 'dva'
import Navbar from '../navbar'
import Searchbar from '../searchbar'
import Footer from '../footer'
import FloatButton from '../FloatButton'
import { CartContext } from './context'
import './index.less'

type LayoutProps = {
  children: ReactNode
}

const selector = ({ login }) => ({
  userInfo: login.userInfo,
})
const Layout: FC<LayoutProps> = ({ children }) => {
  const { userInfo } = useSelector(selector, shallowEqual)
  const history = useHistory()
  const location = useLocation()

  /**购物车数量*/
  const [cartNumber, setCartNumber] = useState(0)

  useEffect(() => {
    if (!userInfo?.token) {
      history.replace('/login')
      return
    }
  }, [history, userInfo])

  const floatButtonShow = useMemo(() => {
    const { pathname } = location
    // 首页、搜索查询页、详情页、购物车
    return ['/', '/search', '/detail/book', '/detail/booart', '/cart'].includes(
      pathname
    )
  }, [location])

  return (
    <CartContext.Provider
      value={{
        cartNumber,
        setCartNumber,
      }}
    >
      <header>
        <Navbar></Navbar>
      </header>
      <Searchbar></Searchbar>
      <main>
        <div className="content">{children}</div>
      </main>
      <footer>
        <Footer></Footer>
      </footer>
      {floatButtonShow && <FloatButton />}
    </CartContext.Provider>
  )
}

export default Layout
